module.exports = __webpack_public_path__ + "img/product01-1.29f5a84c.png";